module.exports = __webpack_public_path__ + "img/home-banner.869c87d6.jpg";